export default () => {
  Alpine.data('sortingData', (tours) => ({
    activeFilter: "Default",
    dropdownOpen: false,
    tours: tours,
    getOrder(id) {
      // Find tour data
      const tour = this.tours.find(t => t.id == id);

      if (this.activeFilter === "Default") {
        return this.tours.findIndex(t => t.id == id);
      }
      if (this.activeFilter === "Price: Low to High") {
        // Sort, but missing price at end
        return [...this.tours]
          .sort((a, b) => {
            if (!a.price) return 1;
            if (!b.price) return -1;
            return a.price - b.price;
          })
          .findIndex(t => t.id == id);
      }
      if (this.activeFilter === "Price: High to Low") {
        return [...this.tours]
          .sort((a, b) => {
            if (!a.price) return 1;
            if (!b.price) return -1;
            return b.price - a.price;
          })
          .findIndex(t => t.id == id);
      }
      if (this.activeFilter === "Recommended") {
        // Sort, but missing reviews at end
        return [...this.tours]
          .sort((a, b) => {
            if (!a.reviews) return 1;
            if (!b.reviews) return -1;
            return b.reviews - a.reviews;
          })
          .findIndex(t => t.id == id);
      }
      return 0;
    }
  }))
}